const CookieService = {
  set: (name: string, value: string): void => {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; SameSite=Lax`;
  },

  get: (name: string): string | null => {
    const match = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${name}=`));
    return match ? decodeURIComponent(match.split('=').slice(1).join('=')) : null;
  },

  remove: (name: string): void => {
    document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax`;
  },
};

export default CookieService;
